import { render, staticRenderFns } from "./BlogComponent.vue?vue&type=template&id=ace5a044&scoped=true&"
import script from "./BlogComponent.vue?vue&type=script&lang=ts&"
export * from "./BlogComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BlogComponent.vue?vue&type=style&index=0&id=ace5a044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace5a044",
  null
  
)

export default component.exports